// extracted by mini-css-extract-plugin
export default {"modal":"i_-z","modalContent":"j_-z","footer":"k_-z","cancelBtn":"l_-z","disabled":"m_-z","formWrapper":"n_-z","fade":"o_-z","fade-in":"p_-z","iframe":"q_-z"};